import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { saveCarePlan } from "../../actions/saveCarePlan";
import { useEffect, useState } from "react";
import { getCarePlanData, resetWizardStore } from "../../actions/wizard";
import useClientId from "../../hooks/useClientId";
import { getAssignedClientProfile } from "../../actions/getAssignedClientProfile";
import { AllRoutes } from "../../routes";
import {
  decryptPermissions,
  isPermissionExists,
} from "../../utils/permissionsHelpers";

const Menu = () => {
  const [userPermissions, setUserPermissions] = useState([]);
  // hooks
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { clientId } = useClientId();
  const storeAuth = useSelector((state) => state.auth);
  const storeSettings = useSelector((state) => state.settings);

  const routeMap = {};
  AllRoutes.forEach((route) => {
    routeMap[route.code] = route;
  });

  // effects
  useEffect(() => {
    // save/submit/trigger-API's for client data
    // reset wizard after data submission
    // if user clicks on back/forward button then get support plan for current client from URL
    if (
      !!storeSettings &&
      Object.keys(storeSettings).length > 0 &&
      storeSettings.generalSetting?.prevRoute
    ) {
      const prevRoute = storeSettings.generalSetting?.prevRoute;
      if (prevRoute && prevRoute !== location.pathname) {
        if (prevRoute.includes("plan/")) {
          const path = prevRoute.split("/");
          const prevClientId = parseInt(path[path.length - 1]);
          dispatch(saveCarePlan(prevClientId)).then(() => {
            dispatch(resetWizardStore()).then(() => {
              if (!!clientId && !!prevClientId && prevClientId !== clientId) {
                dispatch(getAssignedClientProfile(clientId));
                dispatch(getCarePlanData(clientId));
              }
            });
          });
        }
        dispatch({
          type: "SETTINGS_UPDATE",
          setting: "prevRoute",
          value: location.pathname,
        });
      }
    }
  }, [location]);

  useEffect(() => {
    if (isPermissionExists()) {
      setUserPermissions(decryptPermissions());
    } else {
      navigate("/login");
    }
  }, [storeAuth]);

  return (
    <div className="app-sidebar">
      <ul className="navbar-nav sidebar sidebar-dark">
        <li className="nav-item">
          <NavLink
            to={`/dashboard`}
            className="nav-link"
            activeclassname="active"
          >
            {routeMap["SUPPORT_PLAN_DASHBOARD"]?.icon}
            <span>Dashboard</span>
          </NavLink>
        </li>
        {userPermissions?.length > 0 &&
          userPermissions.map(
            (routeDetail) =>
              routeDetail.assignable && (
                <li className="nav-item" key={routeDetail.path}>
                  <NavLink
                    to={`/${routeDetail.path}`}
                    className="nav-link"
                    activeclassname="active"
                  >
                    {routeMap[routeDetail.code]?.icon}
                    <span>{routeDetail.name}</span>
                  </NavLink>
                </li>
              ),
          )}
      </ul>
    </div>
  );
};
export default Menu;
